import { Heading, RadioGroup, Span } from "@icg360/design-system";

import { MultiStepFormLayout } from "components/multi-step-form-layout";
import {
  ABOVE_GROUND_POOL_STEP_COUNT,
  IN_GROUND_POOL_STEP_COUNT,
} from "consts";
import { useMultiStepFormState } from "hooks/use-multi-step-form-state";

import {
  PropertyUpdatePoolContext,
  type PropertyUpdatePoolContextState,
} from ".";
import styles from "./property-update-pool.module.scss";

export const PoolDecking = () => {
  const { formNavigate, state, setFields } =
    useMultiStepFormState<PropertyUpdatePoolContextState>(
      PropertyUpdatePoolContext,
    );
  const disableNext =
    !state?.poolDecking ||
    (state?.poolDecking === "Yes" && !state?.poolDeckGateLock);

  const totalSteps =
    state?.poolType === "In-ground"
      ? IN_GROUND_POOL_STEP_COUNT
      : ABOVE_GROUND_POOL_STEP_COUNT;

  return (
    <MultiStepFormLayout
      step={totalSteps - 1}
      totalSteps={totalSteps}
      heading="Is your pool attached to decking?"
      buttonProps={{
        primary: {
          disabled: disableNext,
          path: "../proof",
          text: "Next",
        },
        cancel: { path: "/my/property" },
        formNavigate,
      }}
    >
      <RadioGroup
        aria-label="Pool fence options"
        className={styles.radioGroupDS}
        defaultValue={state?.poolDecking}
        onChange={(value: "Yes" | "No") => setFields({ poolDecking: value })}
      >
        <RadioGroup.Card title="Yes" value="Yes" />
        <RadioGroup.Card title="No" value="No" />
      </RadioGroup>

      {state?.poolDecking === "Yes" ? (
        <>
          <Heading size="lg">
            Does your pool deck have a gate that locks?
          </Heading>
          <RadioGroup
            aria-label="Pool fence options"
            className={styles.radioGroupDS}
            defaultValue={state?.poolDeckGateLock}
            onChange={(value: "Yes" | "No") =>
              setFields({ poolDeckGateLock: value })
            }
          >
            <RadioGroup.Card title="Yes" value="Yes" />
            <RadioGroup.Card title="No" value="No" />
          </RadioGroup>

          <Span color="quiet">
            <Span bold>Gate locks:</Span> The gate should be{" "}
            <Span bold>self-locking, self-latching,</Span> or be secured by{" "}
            <Span bold>a combination lock or padlock.</Span>
          </Span>
        </>
      ) : null}
    </MultiStepFormLayout>
  );
};
